import { appClient } from 'api/apiClient';
import type { RefundDonationResult } from 'types/donations';

/**
 * POST /v1/donations/:id/refund — CLERK+ on the donation's own parish (resolved server-side; no
 * parishId in the URL). Omit `amountCents` for a full refund of whatever remains
 * (amountCents - refundedCents); pass it for a partial refund.
 *
 * `Idempotency-Key` is REQUIRED by the backend — one key per refund attempt, reused on every
 * retry of that same attempt (never generate a fresh one for a retry, or a double-click racing
 * a slow response could refund twice).
 */
export async function refundDonation(donationId: string, idempotencyKey: string, amountCents?: number): Promise<RefundDonationResult> {
    return appClient.post<RefundDonationResult>(`donations/${donationId}/refund`, amountCents != null ? { amountCents } : {}, {
        'Idempotency-Key': idempotencyKey,
    });
}
